import axios from "axios";
import {ordersServicesPath} from "../../../../Constants";
import ObjectUtil from "../../../../utils/common/ObjectUtil";

const materialEstimateUnitUrl = ordersServicesPath + '/organizations/material-estimate-units'

export default class MaterialEstimateUnitService {
    static async create(estimateId, data) {
        return await axios.post(materialEstimateUnitUrl + '?estimateId=' + estimateId
            + '&materialOrganizationOptionId=' + data.material.id + '&quantity=' + data.quantity,
            JSON.stringify({note: data.note}), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async export(orderId, orderName) {
        return axios.get(materialEstimateUnitUrl + '/requests-purchase/download' + '?orderId=' + orderId + "&orderName=" + orderName, {
            responseType: 'blob'
        });
    }

    static async getAllByOrderId(orderId) {
        return axios.get(materialEstimateUnitUrl + '/organization-order' + '?orderId=' + orderId);
    }

    static async getAllByOrderIdForRequestsPurchase(orderId) {
        return axios.get(materialEstimateUnitUrl + '/organization-order-requests-purchase' + '?orderId=' + orderId);
    }

    static async getAllByOrderIdForRequestsCutting(orderId) {
        return axios.get(materialEstimateUnitUrl + '/organization-order-for-add-requests-cutting' + '?orderId=' + orderId);
    }
    static async getAllByOrderIdForOrderEdge(orderId) {
        return axios.get(materialEstimateUnitUrl + '/organization-order-for-add-order-edge' + '?orderId=' + orderId);
    }

    static async getAllPieceMaterialsByOrderId(orderId) {
        return axios.get(materialEstimateUnitUrl + '/organization-order/piece-materials' + '?orderId=' + orderId);
    }

    static async delete(id) {
        return await axios.delete(materialEstimateUnitUrl + '/' + id);
    }

    static async deleteByIds(ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.delete(materialEstimateUnitUrl + '/delete', {
            data: data,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deleteReservesByIds(ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.delete(materialEstimateUnitUrl + '/delete-reserves-by-ids', {
            data: data,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deleteReserves(id) {
        return await axios.delete(materialEstimateUnitUrl + '/' + id + "/delete-reserves", {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }

    static async replacementByMaterialOrganizationOptionId(materialEstimateUnitId, materialOrganizationOptionId) {
        return await axios.put(materialEstimateUnitUrl + '/replacement-by-material-organization-option-id' + '?materialEstimateUnitId=' + materialEstimateUnitId
            + '&materialOrganizationOptionId=' + materialOrganizationOptionId,
            [], {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async issues(ids, orderId) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.patch(materialEstimateUnitUrl + '/issues?orderId=' + orderId, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async editNote(id, note) {
        return await axios.patch(materialEstimateUnitUrl + '/' + id + '/set-note', JSON.stringify({note: note}), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async editQuantity(id, quantity) {
        return await axios.patch(materialEstimateUnitUrl + '/' + id + '/set-quantity?quantity=' + quantity, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async packaging(ids, pack, orderId) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.patch(materialEstimateUnitUrl + '/packaging?pack=' + pack + '&orderId=' + orderId, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}